module.exports = __webpack_public_path__ + "img/ico_arr_down_wh.651826e7.png";